import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { ApiConnectionString } from '../../../constants/ApiConntection'
import { useAuthContext } from '../../../hooks/useAuthContext'
import LoadingSpinner from "../../../components/LoadingSpinner"
import CouponImg from "../../../assets/Coupon/Coupon.png"

export default function ViewCoupons({ selectCoupon, changeView, currentView }) {
  const [coupons, setCoupons] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { user } = useAuthContext();

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const couponResponse = await axios.get(`${ApiConnectionString}/api/Coupons/`, {
        headers: { Authorization: `Bearer ${user.token}` },
      });

      if (couponResponse.status === 200) {
        setCoupons(couponResponse.data);
      }
    } catch (error) {
      console.error('Error fetching coupons:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (currentView === "MainPage") {
      fetchData();
    }
  }, [currentView]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="container my-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold">Discount Coupons</h2>
        <button className="btn btn-primary" onClick={() => changeView("CreateCoupon")}>
          Create Coupon
        </button>
      </div>

      {coupons.length === 0 ? (
        <div className="row align-items-center justify-content-center py-5">
          <div className="col-md-6 text-center mb-4 mb-md-0">
            <img
              src={CouponImg}
              alt="Create your first discount coupon"
              className="img-fluid"
              style={{ maxWidth: '300px' }}
            />
          </div>
          <div className="col-md-6 text-center text-md-start">
            <h4 className="fw-semibold mb-3">No coupons yet</h4>
            <p className="text-muted">
              Coupons let you offer discounts to new or returning members. You can set a fixed amount or a percentage off,
              limit redemptions, and choose how long the discount lasts.
            </p>
            <p className="text-muted">
              Use them to promote signups, reward loyal members, or run limited-time offers.
            </p>
            <button className="btn btn-outline-primary mt-3" onClick={() => changeView("CreateCoupon")}>
              Create your first coupon
            </button>
          </div>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped table-hover">
            <thead className="table-light">
              <tr>
                <th>Name</th>
                <th>Code</th>
                <th>Discount</th>
                <th>Duration</th>
                <th>Usage</th>
                <th>Valid</th>
              </tr>
            </thead>
            <tbody>
              {coupons.map((coupon, index) => (
                <tr key={index} onClick={() => { selectCoupon(coupon.id); changeView("OneCoupon") }} style={{ cursor: 'pointer' }}>
                  <td>{coupon.name}</td>
                  <td>{coupon.promotionCode}</td>
                  <td>{coupon.amountOff ? `£${coupon.amountOff}` : `${coupon.percentOff}%`}</td>
                  <td>{coupon.duration}</td>
                  <td>
                    {coupon.timesRedeemed}
                    {coupon.maxRedemptions && `/${coupon.maxRedemptions}`}
                  </td>
                  <td>{coupon.valid ? 'Valid' : 'Invalid'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
